import { signOut } from "firebase/auth";

export const logoutCoachSession = async ({
  auth,
  coach,
  signOutFn = signOut,
} = {}) => {
  if (!auth || !coach || coach.isOffline) {
    return false;
  }

  try {
    await signOutFn(auth);
    coach.resetCoach();
    coach.setProperty("initialLoading", true);
    return true;
  } catch (error) {
    console.error("error logout", error);
    return false;
  }
};

